<template>
  <v-app>
    <div v-if="filter" class="product-filter grid grid-cols-12 gap-x-4">
      <v-select
          class="filter col-span-12 lg:col-span-3 lg:col-start-4"
          label="Glace-Typ"
          v-model="selectedType"
          :items="itemsTypes"
          outlined
          clearable
      ></v-select>
      <v-select
          class="filter col-span-12 lg:col-span-3 lg:col-start-7"
          label="Bechergrösse"
          v-model="selectedSize"
          :items="itemsSizes"
          outlined
          clearable
      ></v-select>
      <!--<v-select
          class="filter col-span-12 lg:col-span-2 lg:col-start-9"
          label="Sortieren nach..."
          v-model="selectedSort"
          :items="itemsSort"
          outlined
          clearable
      ></v-select>-->
      <div class="col-span-12 flex justify-center filter-reset mb-14">
        <button @click="resetFilters">Filter zurücksetzen</button>
      </div>
    </div>
    <div class="flex flex-wrap gap-y-14 lg:gap-y-28">
      <div v-for="product in filteredProducts" :key="product.id"
           class="text-center w-full md:w-6/12 lg:w-4/12">
        <div class="lg:w-9/12 lg:mx-auto">
          <div class="mb-4 bg-center bg-contain bg-repeat-none lazyload background-image-product"
               :data-bgset="getTransformedSrcSet(product.image[0])"></div>
          <h3 class="text-40 mb-2">{{ product.title }}</h3>
          <div v-html="product.text"></div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import {VApp} from 'vuetify/lib';
import imageService from '../services/imageService';

export default {
  name: 'Products',
  props: ['products', 'filter'],
  components: {
    VApp,
  },
  data: () => ({
    itemsSort: [
      {text: 'A - Z', value: 'a-z'},
      {text: 'Z - A', value: 'z-a'},
      {text: 'Neuste zuerst', value: 'newest'},
      {text: 'Älteste zuerst', value: 'oldest'}
    ],
    selectedSort: null,
    selectedSize: null,
    selectedType: null,
  }),
  methods: {
    getTransformedSrcSet: image => imageService.getTransformedSrcSet(image),
    resetFilters() {
      this.selectedSort = null;
      this.selectedSize = null;
      this.selectedType = null;
    },
    filterBySize(product, selectedSize) {
      if (selectedSize) {
        if (selectedSize.includes('Alle')) {
          return true;
        }
        return product.sizes.includes(selectedSize);
      }
      return true;
    },
    filterByType(product, selectedType) {
      if (selectedType) {
        if (selectedType.includes('Alle')) {
          return true;
        }
        return product.types.includes(selectedType);
      }
      return true;
    },
    sort(a, b) {
      const titleA = a.title.toUpperCase();
      const titleB = b.title.toUpperCase();
      const dateA = new Date(a.dateCreated);
      const dateB = new Date(b.dateCreated);
      switch (this.selectedSort) {
        case "a-z":
          return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
        case "z-a":
          return titleB < titleA ? -1 : titleB > titleA ? 1 : 0;
        case "newest":
          return dateB < dateA ? -1 : dateB > dateA ? 1 : 0;
        case "oldest":
          return dateA < dateB ? -1 : dateA > dateB ? 1 : 0;
        default:
          return;
      }
    }
  },
  computed: {
    filteredProducts() {
      return [...this.products].filter(product =>
          this.filterBySize(product, this.selectedSize) &&
          this.filterByType(product, this.selectedType)
      ).sort(this.sort);
    },
    itemsSizes() {
      let sizes = [];
      this.products.forEach(product => {
        product.cupSize.forEach(size => {
          if (!sizes.includes(size.title)) {
            sizes.push(size.title);
          }
        });
      });
      return ['Alle Bechergrössen', ...sizes];
    },
    itemsTypes() {
      let types = [];
      this.products.forEach(product => {
        product.iceCreamType.forEach(type => {
          if (!types.includes(type.title)) {
            types.push(type.title);
          }
        });
      });
      return ['Alle Glace-Typen', ...types];
    },
  }
};
</script>
